import { ReactElement } from 'react'

import { useTranslation } from 'react-i18next'

import { updateDspLineItem } from 'api/Cerebro/orgScoped/dspApi'
import { userHasManageLabelsPermissions } from 'helpers/featurePermissions'
import { useUserHasPermissions, useResourceOfPage } from 'hooks'
import { DspLineItemGroupBy, Label } from 'types'

import { DeleteField } from '../../SharedFields/DeleteField'

interface Props<RecordType> {
    readOnly: boolean
    record: RecordType
    reloadData: () => void
}

export function RemoveFromLabelField<RecordType extends DspLineItemGroupBy>({
    readOnly = false,
    record,
    reloadData,
}: Props<RecordType>): ReactElement {
    const { t } = useTranslation(['table', 'common'])
    const hasLabelPermissions = useUserHasPermissions(
        userHasManageLabelsPermissions
    )

    const label: Label | null = useResourceOfPage('labelPage')

    const getIsDisabled = (): boolean => {
        return !hasLabelPermissions || readOnly
    }

    return (
        <DeleteField
            disabled={getIsDisabled()}
            okText={t('common:remove', 'Remove')}
            title={t(
                'table:fields.removeLineItemFromLabel.confirmTxt',
                'Are you sure you want to remove this line item from {{name}}?',
                {
                    name: label?.name,
                }
            )}
            updateRequestCallback={reloadData}
            updateRequestApi={updateDspLineItem}
            updateRequestData={record.line_item.id}
            updateRequestParams={{
                remove_label_ids: [label?.id],
            }}
            updateRequestSuccessMesg={t(
                'table:fields.removeLineItemFromLabel.successMsg',
                'Line item successfully removed'
            )}
        />
    )
}
